// filepath: /Users/manishaghi/Documents/project2/briq-construction-website/frontend/src/components/Reviews.js
import React, { useEffect, useState } from 'react';

function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    setReviews([
      { id: 1, text: 'Great work!', author: 'Client A' },
      { id: 2, text: 'Highly recommend.', author: 'Client B' }
    ]);
  }, []);

  return (
    <div>
      <h2>Client Reviews</h2>
      <ul>
        {reviews.map(review => <li key={review.id}>{review.text} - {review.author}</li>)}
      </ul>
    </div>
  );
}

export default Reviews;